import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
const ContactUs = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [categories,setCategories]=useState([]);

  const [handleedit,seteditData]=useState({
    id:null,
   companyname: '',
    text: '',
    media:'',
    whatsappno:'',
    latitude:'',
    longitude:''
  })

  const [showeditmodal,setshoweditmodal]=useState(false); 

  const [formData, setFormData] = useState({
    companyname: '',
    text: '',
    media:'',
    whatsappno:'',
    latitude:'',
    longitude:''

  });
  

  const fetchcategories=async()=>{
    try{
     const res=await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/contact');
     console.log(res.data);
     setCategories(res.data);
    }catch(e){
      setError(e.response?.data?.message || 'Save failed');
    }
  }
  
  useEffect(() => {
   fetchcategories();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleOpenModal = () => {
    setFormData({ name: '' });
    setShowModal(true);
    setError('');
  };
  const handlesave = async () => {
    setLoading(true);
    setError('');
    try {
      const data=new FormData();
      data.append('companyname',formData.companyname);
      data.append('text',formData.text);
      data.append('media',formData.media);
      data.append('whatsappno',formData.whatsappno);
       data.append('whatss',formData.whatss);
        data.append('email',formData.email);
      data.append('latitude',formData.latitude);
      data.append('longitude',formData.longitude);
      await axios.post('https://api.squareandangle.pranatigroup.in/api/admin/contact',data,{
      headers:{
        "Content-Type":'multipart/form-Data'
      }
      });
      setShowModal(false);
      setFormData({ companyname: '', text: '', media: '', whatsappno: '', latitude: '', longitude: '' });
      fetchcategories();
    } catch (e) {
      setError(e.response?.data?.message || 'Save failed');
    } finally {
      setLoading(false);
    }
  };


   const handleeditin=(item)=>{
    seteditData({
      id:item.id,
      companyname:item.name,
      text:item.text,
      media:item.media,
      whatsappno:item.contact,
      whatss:item.whatsapp_no,
      email:item.email,
      latitude:item.latitude,
      longitude:item.longitude
    })
    setshoweditmodal(true);
   }
 
   const handledelete=async(id)=>{
     setLoading(true);
    try{
         await axios.delete(`https://api.squareandangle.pranatigroup.in/api/admin/contact/${id}`);
      fetchcategories();
    }catch(e){
        setError(e.response?.data?.message || 'Save failed');
    }finally{
      setLoading(false);
    }
   }


   const handleupdatecat=async()=>{
     setLoading(true);
     setError('');
    try{

       const data=new FormData();
      data.append('companyname',handleedit.companyname);
      data.append('text',handleedit.text);
      data.append('media',handleedit.media);
      data.append('whatsappno',handleedit.whatsappno);
      data.append('whatss',handleedit.whatss);
      data.append('email',handleedit.email);
      data.append('latitude',handleedit.latitude);
      data.append('longitude',handleedit.longitude);
     
      await axios.put(`https://api.squareandangle.pranatigroup.in/api/admin/contact/${handleedit.id}`,data,{
        headers:{"Content-Type":"multipart/form-data"}
      }
      
      );
      fetchcategories();
      setshoweditmodal(false);
      setLoading(false);
    }catch(e){
      setError(e.response?.data?.message || 'Update failed');
      setLoading(false);
      setshoweditmodal(false);
    }
   }

  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };
  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="container-fluid" style={isMobile ? {} : stylesD}>
        <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">
          <h3 className="m-0">Contact Us</h3>
          <button className="btn btn-primary" onClick={handleOpenModal}>+ Add New</button>
        </div>
        <div className="table-responsive w-100 p-0">
          <table className="table table-bordered table-striped bg-white w-100 m-0">
            <thead className="thead-dark">
              <tr>
                <th>Serial No</th>
                <th>Company Name</th>
                <th>Text</th>
                <th>Image</th>
                <th>Phone No</th>
                <th>Whatsapp No</th>
                 <th>Email</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
            
                {
                categories.length>0 ?(
                
                categories.map((item, index) => (
                <tr key={item.id}>
               
                  <td>{index +1}</td>
                  <td>{item.name}</td>
                  <td>{item.text}</td>
                   <td><img src={uploadUrl(item.media)} alt="pranati website" width="100"/></td>
                   
                   <td>{item.contact}</td>
                   <td>{item.whatsapp_no}</td>
                   <td>{item.email}</td>
                    <td>{item.latitude}</td>
                    <td>{item.longitude}</td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-outline-primary mr-2" onClick={()=>handleeditin(item)}>Edit</button>
                    <button className="btn btn-sm btn-outline-danger" onClick={()=>handledelete(item.id)}>Delete</button>
                  </td>
                </tr>
              ))
                ):(
               <tr>

                <td colSpan="8" className="text-center text-muted">
                  No Company Data Found
                </td>
               </tr>

                )}
            </tbody>

            
           
          </table>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Category</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Company Name"
                  value={formData.companyname} 
                  onChange={(e) => setFormData({ ...formData, companyname: e.target.value })}
                />
                 <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="text"
                  value={formData.text} 
                  onChange={(e) => setFormData({ ...formData, text: e.target.value })}
                />
                <input 
                  type="file"
                  className="form-control mb-2"
                  placeholder="Filename"
                  onChange={(e) => setFormData({ ...formData, media: e.target.files[0] })}
                />
                <input 
                  type="number"
                  className="form-control mb-2"
                  placeholder="Phone No"
                  value={formData.whatsappno} 
                  onChange={(e) => setFormData({ ...formData, whatsappno: e.target.value })}
                />
                 <input 
                  type="number"
                  className="form-control mb-2"
                  placeholder="Whatsapp No"
                  value={formData.whatss} 
                  onChange={(e) => setFormData({ ...formData, whatss: e.target.value })}
                />
                 <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Gmail"
                  value={formData.email} 
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Latitude"
                  value={formData.latitude} 
                  onChange={(e) => setFormData({ ...formData, latitude: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Longitude"
                  value={formData.longitude} 
                  onChange={(e) => setFormData({ ...formData, longitude: e.target.value })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlesave} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {showeditmodal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Category</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setshoweditmodal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Company Name"
                  value={handleedit.companyname} 
                  onChange={(e) => seteditData({ ...handleedit, companyname: e.target.value })}
                />
                 <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="text"
                  value={handleedit.text} 
                  onChange={(e) => seteditData({ ...handleedit, text: e.target.value })}
                />
                <input 
                  type="file"
                  className="form-control mb-2"
                  placeholder="Filename"
                  onChange={(e) => seteditData({ ...handleedit, media: e.target.files[0] })}
                />
                <input 
                  type="number"
                  className="form-control mb-2"
                  placeholder="Whatsapp No"
                  value={handleedit.whatsappno} 
                  onChange={(e) => seteditData({ ...handleedit, whatsappno: e.target.value })}
                />
                 <input 
                  type="number"
                  className="form-control mb-2"
                  placeholder="Whatsapp No"
                  value={handleedit.whatss} 
                  onChange={(e) => seteditData({ ...handleedit, whatss: e.target.value })}
                />
                 <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Gmail"
                  value={handleedit.email} 
                  onChange={(e) => seteditData({ ...handleedit, email: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Latitude"
                  value={handleedit.latitude} 
                  onChange={(e) => seteditData({ ...handleedit, latitude: e.target.value })}
                />
                <input 
                  type="text"
                  className="form-control mb-2"
                  placeholder="Longitude"
                  value={handleedit.longitude} 
                  onChange={(e) => seteditData({ ...handleedit, longitude: e.target.value })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setshoweditmodal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleupdatecat} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default ContactUs;